import APIManager from "../Services/ApiManager/ApiManager";

export const getAllAppsBasedOnStatus = (
status,
  {
    setLoader,
    setApplicationList,
    setErrorMessage,
    setOpenErrorPopup,
    setShowNoAppImage,
    setComponentName,
    setHeaderMessage,
    setCompleteApplicationList,
  }

) => {
    sessionStorage.setItem("selectedAppStatus", status);
        setLoader(true);
    
        // First get all applications for sidebar counts
        APIManager.getAllApplication()
          .then((allApps) => {
            if (allApps.length > 0 && allApps[0].message === undefined) {
              setCompleteApplicationList(allApps);
            }
          })
          .catch((error) => {
            console.error("Error fetching complete application list:", error);
          });
    
        // Then get filtered applications for display
        if (status === "OEM_ACTIVITY_STATUS") return;
        APIManager.getAllApplicationBasedOnStatus(status)
          .then((json) => {
            setApplicationList([]);
    
            if (json.length > 0) {
              if (json[0].message === undefined) {
                setApplicationList(json);
                setLoader(false);
              } else {
                setErrorMessage(json[0].message);
                setOpenErrorPopup(true);
                setLoader(false);
              }
            } else {
              setShowNoAppImage(true);
              setLoader(false);
            }
          })
          .catch((error) => {
            setComponentName("appError");
            setErrorMessage(error.message);
            if (error.message === "jwt expired") {
              setHeaderMessage("401 Token Expired");
            } else {
              setHeaderMessage("Error");
            }
            setOpenErrorPopup(true);
            setLoader(false);
          });
}

export const getAllApplications = ({  
  setLoader,
  setApplicationList,
  setErrorMessage,
  setOpenErrorPopup,
  setShowNoAppImage,
  setComponentName,
  setHeaderMessage,
  setCompleteApplicationList,

}) => {
    sessionStorage.setItem("selectedAppStatus", "all");
    setLoader(true);
    APIManager.getAllApplication()
      .then((json) => {
        setApplicationList([]);

        if (json.length > 0) {
          if (json[0].message === undefined) {
            setApplicationList(json);
            setCompleteApplicationList(json); // Store complete list
            setLoader(false);
          } else {
            setErrorMessage(json[0].message);
            setOpenErrorPopup(true);
            setLoader(false);
          }
        } else {
          setShowNoAppImage(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        setComponentName("appError");
        setErrorMessage(error.message);
        if (error.message === "jwt expired") {
          setHeaderMessage("401 Token Expired");
        } else {
          setHeaderMessage("Error");
        }
        setOpenErrorPopup(true);
        setLoader(false);
      });
}